var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c(
      "a",
      {
        staticClass: "link_recommend",
        attrs: { href: _vm.cafeInfo.contents.url, target: "_blank" },
      },
      [
        _c("div", { staticClass: "box_type_bg" }, [
          _c("img", {
            staticClass: "img_thumb",
            attrs: { src: _vm.cafeInfo.contents.image, alt: "" },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "thumb_frame" }),
          _vm._v(" "),
          _c("div", { staticClass: "box_tbl" }, [
            _c("div", { staticClass: "inner_tbl" }, [
              _c("strong", { staticClass: "tit_name" }, [
                _vm._v(_vm._s(_vm.content)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "txt_info" }, [
                _vm.cafeInfo.popularCafe
                  ? _c("span", { staticClass: "icon pop_ico" }, [
                      _vm._v("인기"),
                    ])
                  : _c("span", { staticClass: "icon rec_ico" }, [
                      _vm._v("추천"),
                    ]),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.cafeInfo.contents.title)),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }